/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Pure helpers for Settings > Real Estate, kept free of imports so they can be
 * unit tested without loading auth/Auth (axios is ESM and does not parse
 * under CRA's jest).
 */

/** The personas to send, or an error message. */
export function validatePersonas(chosen, personas) {
  const licensed = new Set(personas.filter((p) => p.licensed).map((p) => p.code));
  const codes = [...chosen].filter((code) => licensed.has(code));
  if (codes.length === 0) return { error: "Choose at least one kind of business." };
  return { codes };
}
